import { HomeAlertIcon } from './HomeAlertIcon';

/**
 * author: Michael Richins
 * id A13368F4-66F6-4014-968E-7A7B2D99F038
 * name home-alert
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-alert.svg
 * tags
 * - Home Automation 
 * - Alert / Error 
 */
export const HouseWarningIcon = HomeAlertIcon;
export default HouseWarningIcon